export const informacionHistorica = [
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "../../Transparencia/zip/21rubrosstpsh.zip"
            }
        ]
    }
]